// Format date only (no time) without timezone conversion
// Extracts the UTC date from ISO strings to avoid timezone conversion issues
// e.g., "2025-10-19T01:59:59.999+02:00" (which is 2025-10-18 23:59:59.999 UTC) -> "18/10/2025"
export const formatDateOnly = (dateString: string | null | undefined | Date): string => {
    if (!dateString) return '-';

    // Parse as Date object to handle timezone conversion
    const date = dateString instanceof Date ? dateString : new Date(dateString);

    // Use UTC methods to get the original UTC date, avoiding timezone conversion
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');

    // Format as DD/MM/YYYY
    return `${day}/${month}/${year}`;
};
